// modules
import { createAction } from 'redux-actions'

// actions
export const setAlertNotes = createAction('SET_ALERT_NOTES')
